import React, { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useAuth } from './AuthContext';

export default function DemoGuestEntry() {
  const { signInAsDemoGuest, status } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const openDemo = async () => {
    setBusy(true);
    setError('');
    try {
      const result = await signInAsDemoGuest();
      if (!result.ok) setError(result.error?.message || 'Demo access could not be opened. Try again.');
    } catch (_) {
      setError('Demo access could not be opened. Try again.');
    } finally {
      setBusy(false);
    }
  };
  return <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 1200, maxWidth: 320, textAlign: 'right' }}>
    <Button variant="contained" onClick={openDemo} disabled={busy}>{busy ? 'Opening demo…' : 'View demo as guest'}</Button>
    <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>Demo account · read only</Typography>
    {(error || status.mode === 'demo' && status.message) && <Alert severity="warning" sx={{ mt: 1 }}>{error || status.message}</Alert>}
  </Box>;
}
